import Starfield from './Starfield';

export default function Experience() {
  return (
    <>
      <ambientLight intensity={0.08} />
      <directionalLight position={[5, 8, 5]} intensity={0.4} castShadow color="#ffffff" />
      <pointLight position={[-6, 3, 2]}  color="#E8001D" intensity={2}   distance={20} />
      <pointLight position={[6, -3, -5]} color="#E8001D" intensity={1.5} distance={20} />
      <pointLight position={[0, 0, -12]} color="#ff2200" intensity={2}   distance={25} />

      <Starfield />
    </>
  );
}
